import { z } from "zod";
import { isoDateSchema } from "@common/helpers/date";
import { InvoiceStatus } from "@common/types/invoice";

// Bulk lifecycle transitions only ever set VOID or UNCOLLECTABLE — both are
// terminal-ish, date-stamped statuses reachable from the same per-invoice
// status dropdown (ConfirmInvoiceStatusDateModal), which this endpoint's
// frontend caller reuses for the date prompt. PAID/OPEN have their own
// dedicated flows (record payment / finalize) that don't generalize to a
// blind bulk transition, so they are intentionally excluded here.
export const BULK_INVOICE_STATUS_VALUES = [
    InvoiceStatus.VOID,
    InvoiceStatus.UNCOLLECTABLE,
] as const;

export const bulkUpdateInvoiceStatusBodySchema = z.object({
    invoiceIds: z
        .array(z.string().uuid())
        .min(1)
        .max(200)
        .refine(
            (invoiceIds) => new Set(invoiceIds).size === invoiceIds.length,
            {
                message: "invoiceIds must not contain duplicates",
            },
        ),
    status: z.enum(BULK_INVOICE_STATUS_VALUES),
    date: isoDateSchema,
});

export type BulkUpdateInvoiceStatusBody = z.infer<
    typeof bulkUpdateInvoiceStatusBodySchema
>;
